<div class="vtr-snapshot-main">
	<div class="row">
		<div class="col col-12">
			<vtr-snapshot-header></vtr-snapshot-header>
		</div>
	</div>

	<div class="row">
		<div class="col col-12">

			<!-- Link Export Snapshot -->
			<vtr-ui-hyperlink-button
				class="export-snapshot-btn"
				linkId="snapshot-export-log-btn"
				linkRole="button"
				hyperlinkStyle="xs-300-blue-lighter"
				imgIconSrc="{{ getExportIcon( !isButtonEnabled() ) }}"
				[isDisabled]="!isButtonEnabled()"
				(hyperlinkClick)="exportLog()"
				[label]="'snapshot.exportLogModal.exportSnapshot' | translate">
			</vtr-ui-hyperlink-button>
		</div>
	</div>

	<div class="row export-button-available">
		<div class="col col-12">
			<vtr-ui-snapshot-item-list
				[hostPage]="'SnapshotPage'"
				[title]="'snapshot.hardwareListTitle' | translate"
				[snapshotComponents]='hardwareComponents'
				[componentType]="'hardware'">
			</vtr-ui-snapshot-item-list>
		</div>
	</div>

	<div class="row">
		<div class="col col-12">
			<vtr-ui-snapshot-item-list
				[hostPage]="'SnapshotPage'"
				[title]="'snapshot.softwareListTitle' | translate"
				[snapshotComponents]='softwareComponents'
				[componentType]="'software'">
			</vtr-ui-snapshot-item-list>
		</div>
	</div>
</div>
